import { useFormContext } from "react-hook-form";

import { MultiSelectQuestion } from "../components/MultiSelectQuestion";
import { SurveyStepLayout } from "../components/SurveyStepLayout";
import { type ScreeningSurveyFormData } from "../lib/screeningSurveySchema";
import { type Language, languageLabels } from "../lib/screeningSurveyTypes";

const options = Object.entries(languageLabels).map(([value, label]) => ({
  value: value as Language,
  label,
}));

interface LanguagesStepProps {
  onContinue: () => void;
  onBack: () => void;
  currentStep: number;
  totalSteps: number;
}

export function LanguagesStep(props: LanguagesStepProps) {
  const { onContinue, onBack, currentStep, totalSteps } = props;
  const { watch, setValue } = useFormContext<ScreeningSurveyFormData>();
  const value = watch("languages") ?? [];

  return (
    <SurveyStepLayout
      currentStep={currentStep}
      totalSteps={totalSteps}
      title="Do you know any of the following languages?"
      subtitle="Select all that apply."
      continueDisabled={value.length === 0}
      onBack={onBack}
      onContinue={onContinue}
    >
      <MultiSelectQuestion
        options={options}
        selectedValues={value}
        onChange={(v) => {
          setValue("languages", v);
        }}
      />
    </SurveyStepLayout>
  );
}
